var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_658_6609)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.939 0.796875C30.665 0.796875 39.3906 9.5225 39.3906 20.2485C39.3906 30.9744 30.665 39.7 19.939 39.7C9.21309 39.7 0.487465 30.9744 0.487465 20.2485C0.487465 9.5225 9.21309 0.796875 19.939 0.796875ZM15.5511 27.2073C14.9173 27.841 14.9173 28.8655 15.5511 29.4993C15.8672 29.8154 16.2821 29.9742 16.6972 29.9742C17.1121 29.9742 17.5271 29.8154 17.8432 29.4993L25.948 21.3945C26.5818 20.7607 26.5818 19.7363 25.948 19.1025L17.8431 10.9976C17.2094 10.3639 16.1849 10.3639 15.5511 10.9976C14.9173 11.6314 14.9173 12.6559 15.5511 13.2897L22.5099 20.2485L15.5511 27.2073Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_658_6609"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.9032,
    height: 38.9032,
    fill: "white",
    transform: "matrix(-1 0 0 1 39.3906 0.796875)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.0de97334a43345e9606f99c67bfad694.svg";
export { ForwardRef as ReactComponent };